// extracted by mini-css-extract-plugin
module.exports =  {"tc-enumeration-header":"Header-module__tc-enumeration-header___BZBAj","tc-enumeration-header-error":"Header-module__tc-enumeration-header-error___AV_4F"};